"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getValidator = exports.validators = exports.validateVideo = exports.validateImage = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _I18n = _interopRequireDefault(require("I18n"));

var _FloatingAlertStore = _interopRequireDefault(require("UIComponents/alert/FloatingAlertStore"));

var _file = require("FileManagerCore/utils/file");

var _Constants = require("FileManagerLib/Constants");

var _validators;

var validateImage = function validateImage(file) {
  if (!(0, _file.isImage)(file)) {
    _FloatingAlertStore.default.addAlert({
      type: 'danger',
      titleText: _I18n.default.text('FileManagerLib.notifications.upload.expectedImage.title'),
      message: _I18n.default.text('FileManagerLib.notifications.upload.expectedImage.message', {
        filename: file.name
      })
    });

    return false;
  }

  return true;
};

exports.validateImage = validateImage;

var validateVideo = function validateVideo(file) {
  if (!(0, _file.isVideo)(file)) {
    _FloatingAlertStore.default.addAlert({
      type: 'danger',
      titleText: _I18n.default.text('FileManagerLib.notifications.upload.expectedVideo.title'),
      message: _I18n.default.text('FileManagerLib.notifications.upload.expectedVideo.message', {
        filename: file.name
      })
    });

    return false;
  }

  return true;
};

exports.validateVideo = validateVideo;
var validators = (_validators = {}, (0, _defineProperty2.default)(_validators, _Constants.DrawerTypes.IMAGE, validateImage), (0, _defineProperty2.default)(_validators, _Constants.DrawerTypes.VIDEO, validateVideo), (0, _defineProperty2.default)(_validators, _Constants.DrawerTypes.HUBL_VIDEO, validateVideo), _validators);
exports.validators = validators;

var getValidator = function getValidator(type) {
  return validators[type] || null;
};

exports.getValidator = getValidator;